/**
 * Remove third-party vendor names from operator-facing UI text.
 */

const REPLACEMENTS = [
  [/ComplyAdvantage\s+PEP\s+Data/gi, 'PEP watchlist data'],
  [/GBG\s*green\s*ID/gi, 'document verification'],
  [/green\s*ID/gi, 'document verification'],
  [/ComplyAdvantage/gi, 'watchlist'],
  [/\bGBG\b/gi, ''],
  [/Dow\s*Jones/gi, 'reference database'],
  [/\bCA profile(s)?\b/gi, 'structured profile(s)'],
  [/\bCA customer ID\b/gi, 'screening reference'],
  [/\bCA portal\b/gi, 'administrator portal'],
  [/interactive stub/gi, 'test scenario'],
  [/\s{2,}/g, ' '],
  [/\(\s+/g, '('],
  [/\s+\)/g, ')']
]

export function sanitizeVendorBranding(text) {
  if (text == null || text === '') return text == null ? null : ''
  let out = String(text)
  for (const [pattern, replacement] of REPLACEMENTS) {
    out = out.replace(pattern, replacement)
  }
  out = out
    .replace(/document verification(\s+document verification)+/gi, 'document verification')
    .replace(/watchlist\s+watchlists/gi, 'watchlists')
    .trim()
  return out
}

/** @param {string|null|undefined} provider */
export function isWatchlistAmlProvider(provider) {
  const p = String(provider || '').toLowerCase()
  return p === 'greenid' || p === 'watchlist'
}

/** Operator-safe provider label (never vendor names). */
export function formatAmlProviderForUi(provider) {
  const p = String(provider || '').toLowerCase()
  if (isWatchlistAmlProvider(p) || p === 'amlwatcher' || p === 'external') {
    return 'Watchlist screening'
  }
  if (p === 'dowjones') return 'Reference database'
  return provider ? sanitizeVendorBranding(provider) : null
}
